import React from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns } from './configuration';
import * as NotificationReducer from '../../../../redux/reducers/reimbursements_received_list_reducer/selectors';
import { useDispatch } from 'react-redux';
import ReimbursementsReceivedListActions from '../../../../redux/reducers/reimbursements_received_list_reducer/actions';
import { Box } from '@material-ui/core';
import Filter from '../filter';
import useQuery from 'custom_hooks/useQuery';
import * as AuthSelectors from '../../../../redux/reducers/gl_auth_reducer/selectors';
import { AuthRoles } from 'config';

export default function DatatableList() {
  const ROLE = AuthSelectors.useSelectUserRole();

  const result = NotificationReducer.useGetReimbursementsReceivedList();
  const paging = result.data?.paging;
  const dispatch = useDispatch();
  const sortField = React.useRef<string>(TableColumns[0].id);
  const sortType = React.useRef<'asc' | 'desc'>('desc');

  const query = useQuery();
  const vat_num = query.get('vat_num');
  const originatingCountry = query.get('originatingCountry');
  const schemeType = query.get('schemeType');
  let searchParams = {
    ...(vat_num && { vat_num }),
    ...(originatingCountry && { originatingCountry }),
    ...(schemeType && { schemeType }),
  };

  return (
    <Box display="flex" flexDirection="column">
      {(ROLE === AuthRoles.Agent || ROLE === AuthRoles.Admin) && (
        <Filter
          vat_number={vat_num}
          originatingCountry={originatingCountry}
          schemeType={schemeType}
          role={ROLE}
        />
      )}

      <Datatable
        loading={true}
        sorting={{
          sortField: sortField.current,
          order: sortType.current,
        }}
        paging={paging}
        data={result.data?.items || []}
        columns={TableColumns}
        changePageHandle={(selectedPage, pageSize, order, _sortField) => {
          sortType.current = order;
          sortField.current = _sortField;
          dispatch(
            ReimbursementsReceivedListActions.fetchReimbursementsReceivedListAction(
              {
                sortField: _sortField,
                page: selectedPage,
                pageSize: pageSize,
                order: order,
                ...searchParams,
              }
            )
          );
        }}
      />
    </Box>
  );
}
